import { useMemo } from 'react'

import AppActionCreators from '../action-creators/AppActionCreators'
import { useComposerMode } from '../components/composer-footer/useComposerMode'
import AppStore from '../stores/AppStore'

const backToOmni = (): void => {
  AppActionCreators.updateOmniboxState(true)
}

export const useBackToOmni = (): {
  backToOmni: () => void
  canGoBackToOmni: boolean
} => {
  // in case it's null the omnibox has not been initialized yet
  const composerMode = useComposerMode()
  const canGoBackToOmni =
    AppStore.getIsOmniboxEnabled() === false && composerMode === 'new-post'

  return useMemo(() => ({ backToOmni, canGoBackToOmni }), [canGoBackToOmni])
}
